module.exports = __webpack_public_path__ + "static/media/error.843d9541.svg";